import { useState } from 'react';

import { defined } from '../../../utils/defined';
import {
	useOrderQuery,
	useOrderStatusSubscription,
	OrderStatusFieldsFragment
} from '../../graphql';
import { LiveOrderStatusUpdate, LiveOrder } from '../../types';

export const useOrder = (
	id?: string,
	appUserId?: number,
	onUpdate?: LiveOrderStatusUpdate
): LiveOrder => {
	const [status, setStatus] = useState<OrderStatusFieldsFragment>();

	const { data, error } = useOrderQuery({
		skip: id === undefined,
		fetchPolicy: 'network-only',
		variables: {
			id: id ?? '',
			appUserId: appUserId
		}
	});

	const { error: subscriptionError } = useOrderStatusSubscription({
		skip: id === undefined,
		fetchPolicy: 'network-only',
		variables: { id: id ?? '' },
		onData({ data: { data } }) {
			if (data?.orderStatus) {
				setStatus(data.orderStatus);
				onUpdate && onUpdate(data.orderStatus);
			}
		}
	});

	return {
		order: defined(data)
			? {
					...data.order,
					status: status ?? data.order.status
				}
			: undefined,
		error,
		subscriptionError
	};
};
